var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "d-block"
    },
    [
      _c(
        "div",
        {
          staticClass: "gg-btns-list-group"
        },
        [
          _vm._t("default", null, {
            isActive: _vm.isActive,
            handleClick: _vm.handleClick,
            getItemValue: _vm.getItemValue,
            getItemText: _vm.getItemText,
            normalizedSelection: _vm.normalizedSelection
          })
        ],
        2
      ),
      _vm.errorMessages && _vm.errorMessages.length
        ? _c(
            "small",
            {
              staticClass: "error--text mt-1",
              attrs: {
                role: "alert"
              }
            },
            [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }